



























































































































import { Component, Vue, Ref } from "vue-property-decorator";
import SliderToggler from "./SliderToggler.vue";
import DriversHost from "./DriversHost.vue";
import DriversDisplay from "./DriversDisplay.vue";
import PersonDisplay from "./PersonDisplay.vue";
import CarForm from "../FormParts/CarForm.vue";
import CarDisplay from "./CarDisplay.vue";
import PersonContacts from "../FormParts/PersonForm/PersonContacts.vue";
import CardInfoDisplay from "_C/main/Step4/CardInfoDisplay.vue";
import { RecentCardsHelper } from "@/core/helpers/RecentCardsHelper";
import { InsuranceCard } from "@/services/index.defs";
import ContactDisplay from "_C/main/Step4/ContactDisplay.vue";
import { GaHelper } from "@/core/helpers/ga";
import { CalcState, CalcStatus } from "@/models/Models";
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

@Component({
    components: {
        ContactDisplay,
        CardInfoDisplay,
        SliderToggler,
        DriversHost,
        DriversDisplay,
        PersonDisplay,
        CarForm,
        CarDisplay,
        PersonContacts
    }
})
export default class Step4 extends Vue {
    owner = null;

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    @Ref("info") info: { isEdit: Function };
    @Ref("drivers") drivers: { isEdit: Function };
    @Ref("car") car: { isEdit: Function };
    @Ref("insurer") insurer: { isEdit: Function };
    @Ref("owner") ownerDisp: { isEdit: Function };
    @Ref("contact") contact: { isEdit: Function };
    // это нужно переносить в стор, а не передавать на два уровня выше
    isEditing(): boolean {
        return (
            this.info.isEdit() ||
            this.drivers.isEdit() ||
            this.car.isEdit() ||
            this.insurer.isEdit() ||
            (this.card.insurerIsOwner ? false : this.ownerDisp.isEdit()) ||
            this.contact.isEdit()
        );
    }

    mounted() {
        GaHelper.send("overview");
    }

    errorMessage = "";
    loading = false;

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    async issueCard() {
        this.errorMessage = "";
        if (this.card.haveDoubleDrivers) {
            this.errorMessage =
                "У нескольких водителей совпадает серия и номер водительского удостоверения";
            return;
        }
        if (this.isEditing()) {
            this.errorMessage =
                "Отмените или сохраните изменения в одном из блоков";
            return;
        }
        RecentCardsHelper.rememberCard(
            this.card,
            RecentCardsHelper.createCardName(this.$store, this.card)
        );
        console.log(this.card);
        this.loading = true;

        this.$store.direct.state.dicti.providers.forEach(prov => {
            const calc = new CalcState();
            calc.insuranceProviderId = prov.code;
            calc.status = CalcStatus.NeedToCalc;
            this.$store.direct.commit.iccalc.addCalcResult(calc);
        });
        await this.$store.direct.dispatch.insurance.saveAndFullIssue(this.card);
        this.loading = false;
        this.$root.scrollUp();
        sendPostMessageEvent(EventName.FullCalc);
        this.$emit("next");
    }
}
